import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotification } from 'src/hooks/use-notification';

import { RetryTaskPromiseParams, retryTaskPromise } from 'src/utils/api/retry-task';
import { QUERY_KEY_MAP } from 'src/constants/query-key';

export const useRetryTask = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, isError } = useMutation({
    mutationFn: retryTaskPromise,
  });
  const { enqueueErrorNotification, enqueueSuccessNotification } = useNotification();

  const retryTaskAsync = async (params: RetryTaskPromiseParams) => {
    try {
      const res = await mutateAsync(params);
      if (!res) {
        enqueueErrorNotification('Something went wrong');
        return false;
      }

      enqueueSuccessNotification('Retry task successful');

      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useListTasks],
      });

      return true;
    } catch (e) {
      enqueueErrorNotification((e as Error)?.message || 'Unknown error');
      return false;
    }
  };

  return {
    retryTaskAsync,
    isPending,
    isError,
  };
};
